<template>
    <div class="flex items-center relative">
        <input :id="id" type="checkbox" :value="value" :disabled="disabled"
               :checked="modelValue.includes(value)" @change="toggleValue"
               class="peer hidden"/>
        <label :for="id"
               class="min-w-4 min-h-4 border bg-grayBg border-gray-300 rounded-sm cursor-pointer
                      relative flex items-center justify-center text-black text-xs font-bold
                      transition-colors duration-300
                      peer-checked:bg-baseColor peer-checked:border-baseColor">
            <transition
                enter-active-class="transition duration-150 ease-out transform"
                enter-from-class="translate-y-2 opacity-0"
                enter-to-class="translate-y-0 opacity-50"
                leave-active-class="transition duration-100 ease-in transform"
                leave-from-class="translate-y-0 opacity-50"
                leave-to-class="translate-y-2 opacity-0">
                <IconCheckMark v-if="modelValue.includes(value)"
                               class="w-3 h-3 text-black"/>
            </transition>
        </label>
        <slot class="ml-2"/>
    </div>
</template>

<script setup>
import IconCheckMark from "@js/components/Icons/IconCheckMark.vue";

const props = defineProps({
    id: String,
    value: [String, Number, Boolean],
    modelValue: {
        type: Array,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['update:modelValue'])

function toggleValue(event) {
    if (props.disabled) return

    const checked = event.target.checked
    const newValue = [...props.modelValue]

    if (checked) {
        newValue.push(props.value)
    } else {
        const index = newValue.indexOf(props.value)
        if (index > -1) {
            newValue.splice(index, 1)
        }
    }

    emit('update:modelValue', newValue)
}
</script>
